import { defineComponent as m, ref as c, onServerPrefetch as v, onMounted as d, watch as s, h as o } from "vue";
import { extractRootHtmlElement as h } from "@scalar-org/vue-render";
import { resolveLibraryIcon as y } from "../libraries/index.js";
import { fetchAsset as g } from "./resolveAndFetchIcon.js";
function w(e) {
  e.target instanceof HTMLElement && (e.target.style.visibility = "hidden", e.target.classList.add("t-editor__detail-icon--error"));
}
function l(e) {
  const a = y(e);
  return a || e;
}
const M = m({
  props: ["src", "title", "mask"],
  setup(e) {
    const a = typeof e.src == "object" ? e.src.src : e.src || "", r = c(l(a)), i = c();
    function u(t) {
      const f = typeof t == "object" ? t.src : t;
      r.value = l(f);
    }
    async function n(t) {
      i.value = await g(t);
    }
    return v(async () => await n(r.value)), d(async () => !i.value && await n(r.value)), s(() => e.src, u), s(r, n), () => {
      if (i.value) {
        const t = h(i.value);
        if (t.tagName === "svg")
          return o(t.tagName, {
            ...t.properties,
            width: e.size,
            height: e.size,
            class: { ...t.properties.class, ...e.classes },
            innerHTML: t.innerHTML
          });
      }
      return o("img", {
        // Only render the URL (props.src might be an icon key)
        src: r.value,
        alt: e.title,
        width: e.size,
        height: e.size,
        style: "object-fit: contain;",
        class: e.classes,
        onError: w
      });
    };
  }
});
export {
  M as GuideIcon
};
